import api from '@/soluqr/api/client';
import { getCustomerSessionToken, saveCustomerSessionFromApi } from '@/lib/localCustomer';
import { normalizeCustomerPhone } from '@/lib/phone';

/**
 * Garantiza token X-Customer-Session antes de subir comprobante (prod con CUSTOMER_SESSION_ENFORCE).
 * @param {string} businessId
 * @param {{ name?: string, phone?: string, email?: string, address?: string }} customer
 * @returns {Promise<string>}
 */
export async function ensureCustomerSessionForUpload(businessId, customer) {
  const bid = String(businessId ?? '').trim();
  if (!bid) {
    throw new Error('Negocio no disponible');
  }

  const name = String(customer?.name ?? '').trim();
  const phone = normalizeCustomerPhone(customer?.phone ?? '');
  if (!name || phone.length < 8) {
    throw new Error('Completá tu nombre y teléfono antes de subir el comprobante');
  }

  // Siempre refrescar sesión: un token guardado puede estar vencido y el upload devuelve 401.
  const { data } = await api.post('/customers/upsert', {
    business_id: bid,
    phone,
    name,
    email: String(customer?.email ?? '').trim() || undefined,
    address: String(customer?.address ?? '').trim() || undefined,
  });
  saveCustomerSessionFromApi(bid, data);

  const token = getCustomerSessionToken(bid);
  if (!token) {
    throw new Error('No se pudo iniciar sesión. Esperá un momento e intentá de nuevo.');
  }
  return token;
}
